<ng-template #step1>
  <div
    class="dialog__body dialog__body--scroll dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey"
  >
    <div class="dialog__inner">
      <h3 class="dialog__sub-heading">{{ "Selfservice.BGP.Subheading" | translate }}</h3>
      <p class="no-margin">{{ "Selfservice.BGP.Text" | translate }}</p>
    </div>
    <div>
      @for (sap of sapsCopy(); track $index) {
        <bgp-sap-row [sap]="sap" [index]="$index" />
      }
    </div>
  </div>
  <div class="dialog__bottom-message">
    <div class="dialog__bottom-message-inner">
      <svg-icon src="assets/images/icons/status-failure.svg" class="dialog__bottom-message-icon"></svg-icon>
      <span> {{ "Selfservice.BGP.Message" | translate }} </span>
    </div>
  </div>
</ng-template>

<ng-template #step2>
  <div
    class="dialog__body dialog__body--scroll dialog__body--flex-justify dialog__body--no-padding dialog__body--grow dialog__body--grey"
  >
    <div class="dialog__inner">
      <h3 class="dialog__sub-heading">{{ "Global.Summary" | translate }}</h3>
      <p class="no-margin t-newline">{{ "Selfservice.BGP.SummaryText" | translate }}</p>
    </div>

    <div class="dialog__port-summary">
      @for (sap of sapsCopy(); track $index) {
        <bgp-sap-summary-row [sap]="sap" [index]="$index" [initialPriority]="sap.initialBgpSessionPriority" />
      }
    </div>
  </div>
</ng-template>

<selfservice-wizard [steps]="[step1, step2]" [getCommand]="buildCommand" [bus]="bus()" />
